import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateExceptionAddonsView } from './addons/addons';
import { TemplatesCreateControllerModule } from './controllers/TemplatesCreateController';
import { TemplatesCreateDescriptionView } from './description/description';
import { TemplatesCreateExceptionView } from './exceptions/exceptions';
import { TemplatesCreateFlexpayView } from './flexpay/flexpay';
import { TemplatesCreatePricingView } from './pricing/pricing';
import { TemplatesCreateSchedulesView } from './schedules/schedules';

export const TemplatesCreateView = angular
  .module('acme.view.application.templates.create', [
    uiRouter,
    'ui.bootstrap',
    'summernote',
    TemplatesCreateControllerModule,
    TemplatesCreateDescriptionView,
    TemplatesCreateSchedulesView,
    TemplatesCreatePricingView,
    TemplatesCreateFlexpayView,
    TemplatesCreateExceptionAddonsView,
    TemplatesCreateExceptionView,
    'acme.common.directive.spectrum',
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.templates.create',
      url: '/create',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'TemplatesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template',
        permissions: ['EVENT_TEMPLATE_CREATE'],
      },
      resolve: {
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
        spectrum: LoadScriptResolver({ id: 'spectrum-js', url: '/assets/spectrum.min.js' }),
        spectrumCss: LoadCssResolver({ id: 'spectrum', url: '/assets/spectrum.min.css' }),
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit',
      url: '/:id/edit?force',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'TemplatesCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/create.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template',
        permissions: ['EVENT_TEMPLATE_UPDATE'],
        features: {
          objectLock: {
            type: 'EventTemplate',
            views: ['application.templates.edit'],
          },
        },
      },
      resolve: {
        bootstrap: LoadScriptResolver({ id: 'bootstrap-js', url: '/assets/bootstrap.min.js' }),
        summernote: LoadScriptResolver({ id: 'summernote-js', url: '/assets/summernote.min.js' }),
        summernoteCss: LoadCssResolver({ id: 'summernote', url: '/assets/summernote.css' }),
        spectrum: LoadScriptResolver({ id: 'spectrum-js', url: '/assets/spectrum.min.js' }),
        spectrumCss: LoadCssResolver({ id: 'spectrum', url: '/assets/spectrum.min.css' }),
      },
    });
  }).name;
